import React from "react";
import { ErrorNavigationContext } from "../ErrorNavigationContext";

export function useErrorNavigationActions() {
  return React.useContext(ErrorNavigationContext).actions;
}
